import React, { createContext, useContext, useMemo } from 'react'

/** Única identidad visual activa (Deep Space). No hay selector de tema ni layout preset. */
export type ThemeId = 'deepSpace'

const AppExperienceContext = createContext<ThemeId>('deepSpace')

export function AppExperienceProvider({ children }: { children: React.ReactNode }) {
  const value = useMemo(() => 'deepSpace' as const, [])
  return <AppExperienceContext.Provider value={value}>{children}</AppExperienceContext.Provider>
}

export function useThemeId(): ThemeId {
  return useContext(AppExperienceContext)
}
